import { Modal, ModalHeader, ModalBody, ModalFooter } from '@abbyy/react-ui';
import { IconButton } from '..';
import { CrossThin } from '../icons';

interface DialogProps {
    isOpen: boolean;
    onClose?: any;
    children: any;
    height?: number;
    width?: number;
}

export const Dialog = ({ children, height, width, ...props }: DialogProps) => (
    <Modal
        width={width}
        height={height ?? 600}
        hasBackdrop={true}
        closeOnBackdropClick={true}
        {...props}>
        {children}
    </Modal>
);

interface DialogHeaderProps {
    title: string;
    onClose?: any;
}

const Header = ({ title, onClose }: DialogHeaderProps) => {
    return (
        <ModalHeader
            actions={
                <IconButton icon={<CrossThin size={20} />} onClick={onClose} />
            }>
            {title}
        </ModalHeader>
    );
};

Dialog.Header = Header;
Dialog.Body = ModalBody;
Dialog.Footer = ModalFooter;
